enum SettingsConfigurationType {
  DEVICE = 'device',
  SPACE = 'space',
  GLOBALSETTINGS = 'global-settings',
}

export default SettingsConfigurationType;
